module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_6000.4e973e83.png";